import { useMutation, useQueryClient } from "@tanstack/react-query";
import { notification } from "antd";
import { storage } from "utils/storage";
import { useLocation } from "react-router-dom";
import { auth } from "../../firebase/firebase"; 

export function useVerifyOtp() {
  const queryClient = useQueryClient();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const roleType = queryParams.get("roleType");

  async function verifyFirebaseUser(params: { emailOrPhone: string; companyName: string }) {
    const user = auth.currentUser;

    if (!user) {
      throw new Error("User not found. Please log in again.");
    }

    await user.reload(); 

    const userInfo = {
      userName: user.displayName,
      email: user.email,
      role: roleType || "Enumerator",
      uid: user.uid,
      country: "Nepal",
      firstName: user.displayName?.split(" ")[0] || "Unknown",
      lastName: user.displayName?.split(" ")[1] || "User",
    };

  
    const token = await user.getIdToken();
    storage.setUserInStorage(userInfo);
    storage.setTokenInStorage(token);

    return { data: userInfo, token };
  }

  return useMutation({
    mutationFn: verifyFirebaseUser,
    onSuccess: async ({ data, token }) => {
      await queryClient.invalidateQueries();

      notification.success({
        message: "Account Created",
        description: "You can now proceed with profile setup.",
      });

      storage.setUserInStorage(data);
      storage.setTokenInStorage(token);
    },
    onError: (error) => {
      notification.error({
        message: "Verification Failed",
        description: error.message,
      });
    },
  });
}

